import { IconProps } from '@velocity-exchange/icons';
import { cj } from 'src/utils/classNames';

export default function WarningFilled({
	size,
	className,
	...props
}: IconProps) {
	return (
		<span className={cj('inline-flex', className)} {...props}>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width={size}
				height={size}
				viewBox="0 0 16 16"
				fill="none"
			>
				<path
					d="M12 2C13.1046 2 14 2.89543 14 4V12C14 13.1046 13.1046 14 12 14H4C2.89543 14 2 13.1046 2 12V4C2 2.89543 2.89543 2 4 2H12ZM7.83301 10.667C7.37293 10.6672 7 11.0399 7 11.5C7 11.9601 7.37293 12.3328 7.83301 12.333H8.16602C8.62625 12.333 9 11.9602 9 11.5C9 11.0398 8.62625 10.667 8.16602 10.667H7.83301ZM7.80859 3.33301C7.20399 3.33322 6.7375 3.86647 6.81738 4.46582L7.49609 9.55957C7.52973 9.81162 7.74575 9.99983 8 10C8.25422 9.99982 8.46926 9.81157 8.50293 9.55957L9.18164 4.46582C9.26157 3.86634 8.79522 3.33301 8.19043 3.33301H7.80859Z"
					fill={props.color ?? 'currentColor'}
				/>
			</svg>
		</span>
	);
}
